define([
	"csi",
	"csi/def/ActionFactory",
	"csi/sessionConstants",
	"csi/toolbar/CheckedMenuItem",
	"csi/xml",
	"./_CustomViewAction"
], function(csi,ActionFactory,sessionConstants,CheckedMenuItem,xml,_CustomViewAction) {

	return ActionFactory.declare("CustomViewDefault", _CustomViewAction, {
		classController: "csi/view/customview/SetAsDefaultController",
		customViewDirty: false,

		classToolbarPlugin: CheckedMenuItem,
		classToolbarPluginParams: {
			bDisableChecked: true,
			testCheckedFunction: function(/*Context*/ctx) {
				// summary: checked will be true if selected view is the default for its party
				return ctx.view.isDefaultCustomView();
			}
		},

		hasAccess: function(/*Context*/ctx) {
			// summary: allow access if current role being played matches custom view party or is shared site-wide
			var cv = ctx.view.getSelectedCustomView();
			
			// cannot set personal view as default
			if (!cv || cv.isCurrentUser()) {
				return false;
			}

			// TODO: need to update this logic to work with multiple roles
			// cannot set view shared with role as default for site, or as default for another role
			const urlRole = sessionConstants.roleUrl;
			const urlParty = cv.isSharedWithRole(urlRole) ? urlRole : csi.EMPTY_URL;
			
			if (xml.isValidURL(urlParty)) {
				if (!urlRole) {
					return false;
				}
			}
			
			return this.inherited(arguments);
		}
	});
});